<template>
  <div class="sc-breadcrumb">
    <div
      class="xpage-breadcrumbs-wrapper"
      :class="{
        showJumpToNavigation: hasJumpToSlot,
      }"
    >
      <div class="xpage-breadcrumbs">
        <router-link to="/" class="icon-home"></router-link>
        <span>></span>
        <router-link to="/applications">Applications</router-link>
        <span>></span>
        <router-link :to="`/applications/${route.params.referenceId}`">{{
          route.params.referenceId
        }}</router-link>
      </div>
      <div class="loanservice-banner-container" v-if="hasLoanServiceBanner">
        <slot name="loanservice-banner"> </slot>
      </div>
    </div>
    <div class="jumpto-container-wrapper">
      <div class="jumpto-container"><slot name="jumpto"></slot></div>
    </div>
  </div>
  <router-link
    :to="`/loans/${route.params.referenceId}`"
    v-if="viewModel?.loanId && !hasLoanServiceBanner"
    class="loanservice-banner"
  >
    This application has been completed and moved to Loan Service. View Loan >
  </router-link>
</template>
<script setup>
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";
import { useSlots } from "vue";

const store = useApplicationStore();
const { viewModel } = storeToRefs(store);
const route = useRoute();
const slots = useSlots();

const hasJumpToSlot = !!slots.jumpto;
const hasLoanServiceBanner = !!slots["loanservice-banner"];
</script>

<style scoped src="@/assets/css/breadcrumb.css"></style>
